import { Power1, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const stomp: gsapTimelineFunc = (target) => {
  return gsap
    .timeline({ defaults: { ease: Power1.easeOut } })
    .fromTo(
      target,
      { duration: 0, scale: 3, opacity: 0, transformOrigin: 'center center' },
      { duration: 0.1, scale: 1 }
    )
    .to(target, { duration: 0.1, scale: 1.5, rotateZ: -5, opacity: 1 })
    .to(target, { duration: 0.1, scale: 1 })
    .to(target, { duration: 0.1, scale: 1.3, rotateZ: 2 })
    .to(target, { duration: 0.1, scale: 1 })
    .to(target, { duration: 0.1, scale: 1.1, rotateZ: 0 })
    .to(target, { duration: 0.4, scale: 1 });
};
